import cx from 'classnames';

export default function FancyBoxHeading({ children, className }) {
  return (
    <div className={cx('inline-block rounded-md bg-primary-500 px-16', className)}>
      <h2 className="text-2xl text-white md:text-4xl">{children}</h2>
    </div>
  );
}
